import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 80%;
  padding: 0 68px;
  padding-bottom: 60px;
  align-items: center;
`;